import React from "react";
import PricingTable from "./PricingTable";
import { css, useTheme } from "@emotion/react";
import { mediaQueries, pxToRem } from "@upsun/react-component-library/src/styles";
import colorsLight from "@upsun/react-component-library/src/styles/colors-light";
import colorsDark from "@upsun/react-component-library/src/styles/colors-dark";
import { UpsunTheme } from "@upsun/react-component-library/src/themes";

type SupportTableProps = {};

const SupportTable: React.FC<SupportTableProps> = ({ ...props }) => {
  const theme = useTheme() as UpsunTheme;

  const leftColStyles = css`
    width: 100%;

    ${mediaQueries.md} {
      width: 50%;
    }

    p:first-of-type {
      margin-bottom: 0;
    }

    p:nth-of-type(2) {
      font-weight: 400;
      font-size: ${pxToRem(13)};
      margin-bottom: 0;
    }
  `
  const noMargin = css`
    p {
      margin: 0;
    }
  `;

  const disclaimer = css`
    color: ${theme.name === "light" ? colorsLight.NeutralTxtWeakDefault : colorsDark.NeutralTxtWeakDefault};
  `;

  return (
    <PricingTable>
      <tbody>
        <tr>
          <td css={leftColStyles}>
            <p><strong>Standard support</strong></p>
            <p css={disclaimer}>Applied by default</p>
          </td>
          <td css={noMargin}><p><strong>+10% global spend</strong></p><p>4-hour best effort urgent-ticket response time</p></td>
        </tr>
        <tr>
          <td css={leftColStyles}>
            <p><strong>Advanced support</strong></p>
            <p css={disclaimer}>Minimum subscription term is twelve (12) months.</p>
          </td>
          <td css={noMargin}><p><strong>+15% global spend</strong></p><p>1-hour guaranteed urgent-ticket response time</p></td>
        </tr>
        <tr>
          <td css={leftColStyles}>
            <p><strong>Premium support</strong></p>
            <p css={disclaimer}>Minimum subscription term is twelve (12) months.</p>
          </td>
          <td css={noMargin}><p><strong>+19% global spend</strong></p><p>30-min guaranteed urgent-ticket response time</p></td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default SupportTable;
